/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { ContentAiCreateContentMutationRequest, ContentAiCreateContentMutationResponse, ContentAiCreateContent401, ContentAiCreateContent403 } from "../models/ContentAiCreateContent";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { contentAiCreateContent } from "../axios/contentAiCreateContent";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const contentAiCreateContentMutationKey = () => [{ url: '/content-ai/v1/contents' }] as const

export type ContentAiCreateContentMutationKey = ReturnType<typeof contentAiCreateContentMutationKey>

export function contentAiCreateContentMutationOptions<TContext = unknown>(config: Partial<RequestConfig<ContentAiCreateContentMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = contentAiCreateContentMutationKey()
        return mutationOptions<ContentAiCreateContentMutationResponse, ResponseErrorConfig<ContentAiCreateContent401 | ContentAiCreateContent403>, {data: ContentAiCreateContentMutationRequest}, TContext>({
          mutationKey,
          mutationFn: async({ data }) => {
            return contentAiCreateContent(data, config)
          },
        })

}

/**
 * @summary Create content
 * {@link /content-ai/v1/contents}
 */
export function useContentAiCreateContent<TContext>(options: 
{
  mutation?: UseMutationOptions<ContentAiCreateContentMutationResponse, ResponseErrorConfig<ContentAiCreateContent401 | ContentAiCreateContent403>, {data: ContentAiCreateContentMutationRequest}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<ContentAiCreateContentMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? contentAiCreateContentMutationKey()

          const baseOptions = contentAiCreateContentMutationOptions(config) as UseMutationOptions<ContentAiCreateContentMutationResponse, ResponseErrorConfig<ContentAiCreateContent401 | ContentAiCreateContent403>, {data: ContentAiCreateContentMutationRequest}, TContext>
          

          return useMutation<ContentAiCreateContentMutationResponse, ResponseErrorConfig<ContentAiCreateContent401 | ContentAiCreateContent403>, {data: ContentAiCreateContentMutationRequest}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<ContentAiCreateContentMutationResponse, ResponseErrorConfig<ContentAiCreateContent401 | ContentAiCreateContent403>, {data: ContentAiCreateContentMutationRequest}, TContext>
      
}